module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAG1BMVEUAAAA3m/80mv8zmf8zmf80mv9ut//p9P////8lQjLbAAAABnRSTlMAHKbm/+1DRvRuAAAAOElEQVR4AWNgVHZBAkYCDKIuKCCQQSW9AwmUOTGYVCALtDszuHSgAJdBITAqgBFRGFGJEdkYyQEAezPtmz31ad4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/choose_many/assets/checkbox-hover.png
// module id = 537
// module chunks = 0